// Using Vue for the product quantities
// Get the divisible property, from the Tag
let perPanel = document.getElementById('perPanel').value;
let price = document.getElementById('currentPrice').innerHTML;

var elements = document.querySelectorAll('.starter-strips-product');
var elements2 = document.querySelectorAll('.items-per-hundred-sqft');
var hardwareProducts = [];
var starterStripsProducts = [];
elements.forEach(function(item) {
  starterStripsProducts.push({
    id: item.dataset['id'],
    price: item.dataset['price']
  })
})
elements2.forEach(function(item) {
  hardwareProducts.push({
    id: item.dataset['id'],
    sqftPerOne: item.dataset['value'],
    price: item.dataset['price']
  })
})

new Vue({ 
  el: '#PANELquantities',
  data: function () {
    return {
      panelTotals: 0,
      panelQty: 0,
      sqftQty: 0,
      addOnsQty: {},
    }
  },
  computed: 
  {
    totalPrice() {
      var addOnPrices = 0;
      var self = this;
      var panelPrice = this.panelQty * price;
      hardwareProducts.forEach(function(product) {
        var qty = self.addOnsQty[product.id] ? self.addOnsQty[product.id] : 0;
        var addOnPrice = product.price * qty;
        addOnPrices += addOnPrice;
      })
      starterStripsProducts.forEach(function(product) {
        var qty = self.addOnsQty[product.id] ? self.addOnsQty[product.id] : 0;
        var addOnPrice = product.price * qty;
        addOnPrices += addOnPrice;
      })
      var sum = panelPrice + addOnPrices;
      return sum.toFixed(2);
    },
    totalPANEL() {
      return total.totalDimensions;
    },
    allWalls() {
      return total.allDimensions;
    },
    totalSQFT() {
      return total.totalTotal;
    },
    totalWidth(){
      return this.totalInches + this.totalFeet;
    }
  },
  watch: {
    allWalls(walls) {
      if (walls.length > 0) {

        const [panelW, panelH] = perPanel.split('*');
        let quantity = 0

        walls.forEach(wall => {
          const xCount = Math.ceil(wall.w / Number(panelW));
          const yCount = Math.ceil(wall.h / Number(panelH));
          quantity += (xCount * yCount)
        })

        this.panelQty = quantity;
        var value = this.panelQty * Number(panelW) * Number(panelH);
        this.sqftQty = parseInt(value * 100) / 100;
        this.updateAddOnsQty();
      }
    },
    totalSQFT(newV) {
      // this.sqftQty = newV;
    }
  },
  methods:
  {
    updateAddOnsQty() {
      var self = this;
      hardwareProducts.forEach(function (product) {
        self.addOnsQty[product.id] = Math.ceil(self.sqftQty / product.sqftPerOne);
      });
      starterStripsProducts.forEach(function (product) {
        self.addOnsQty[product.id] = Math.ceil(total.totalWidth / 4);
      });
    },
    // PANEL QTY change
    onPANELChange(event) {
      this.panelQty = event.target.value;
      var perPanelSize = perPanel.split('*');
      var value = this.panelQty * Number(perPanelSize[0]) * Number(perPanelSize[1]);
      this.sqftQty = parseInt(value * 100) / 100;
      this.updateAddOnsQty();
    },
    // Hardwares QTY change
    plusQty(variant_id) {
      if (this.addOnsQty[variant_id]) {
        this.addOnsQty[variant_id]++;
      } else {
        this.addOnsQty[variant_id] = 1;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
    // Hardwares QTY change
    minusQty(variant_id) {
      if (this.addOnsQty[variant_id] || this.addOnsQty[variant_id] > 1) {
        this.addOnsQty[variant_id]--;
      } else {
        this.addOnsQty[variant_id] = 0;
      }
      this.addOnsQty = { ...this.addOnsQty }
    },
  }
})


